export default {
  createButton: { id: 'create_button' },
  licenseeApplicationList: { id: 'licensee_application_list' },
  licenseeApplication: { id: 'licensee_application' },
  applications: { id: 'applications' },
  translations: { id: 'translations' },
  application: { id: 'application' },
  licensees: { id: 'licensees' },
  licenseeApplicationInfo: { id: 'licensee_application_info' },
  createLicenseeApplication: { id: 'create_licensee_application' },
  editLicenseeApplication: { id: 'edit_licensee_application' },
  deleteLicenseeApplication: { id: 'delete_licensee_application' },
  deleteLicenseeApplicationMessage: {
    id: 'delete_licensee_application_message',
  },
  showInSideBarMenu: { id: 'show_in_side_bar_menu' },
  enableInUi: { id: 'enable_in_ui' },
  dateUpdated: { id: 'date_updated' },
  orderNumber: { id: 'order' },
}
